// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da04dec8","239":"e3fc8f50","453":"0160847b","455":"6a6aaac3"}[chunkId] + ".chunk.js";
};